import { CultureCode } from '@dustin-web/microsite-config'

export const formatDayMonthYearUTC = (iso: string, cultureCode: CultureCode) => {
  const parsed = Date.parse(iso)

  if (!isNaN(parsed)) {
    const dtf = new Intl.DateTimeFormat(cultureCode, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    })
    return dtf.format(new Date(parsed))
  }

  return iso
}
